import {Payroll, PayrollRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell, Typography} from "@mui/material";
import dayjs from "dayjs";
import {dateFromToString} from "../../../../components/utils/dates";
import {fullName} from "../../../../components/kit";
import {useApiManager} from "../../../../components/utils/api";
import {numberToString} from "../../../../components/utils/numbers";

/** «Septiembre 2026» si el periodo es un mes natural; si no, las dos fechas. */
export const payrollPeriod = (from?: string, to?: string) => {
	const f = from ? dayjs(from) : undefined;
	const t = to ? dayjs(to) : undefined;
	if (f && t && f.date() === 1 && t.isSame(f.endOf("month"), "day")) {
		const s = f.format("MMMM YYYY");
		return s.charAt(0).toUpperCase() + s.substring(1);
	}
	return `${dateFromToString(from)} – ${dateFromToString(to)}`;
};

export const PayrollListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<Payroll> = {
		title: "Nóminas",
		onClick: "/app/admin/employee/payroll",
		headers: [
			{title: "Período"},
			{title: "Persona"},
			{title: "Coste empresa", align: "right"},
		],
		decorator: (bean: Payroll) => (
			< >
				<TableCell>
					<Typography variant="body2" fontWeight={600}>{payrollPeriod(bean.periodFrom, bean.periodTo)}</Typography>
				</TableCell>
				<TableCell>
					{fullName(bean.person)}
				</TableCell>
				<TableCell align={"right"} sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.person.id != 236 && (
						<>
							{numberToString(bean.costeEmpresa)}
						</>
					)}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(PayrollRestControllerApiFactory);
			return ctrl.pagePayroll(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};